import React from 'react';
import { Star } from 'lucide-react';
import { useTheme } from '@root/context/ThemeContext';
import { copyTrackingService } from '@root/services/copyTrackingService';
import './style.scss';

interface CopyTrackingStarProps {
  size?: number;
  className?: string;
  onClick?: () => void;
}

const CopyTrackingStar: React.FC<CopyTrackingStarProps> = ({ 
  size = 18, 
  className = '',
  onClick 
}) => {
  const { isDarkMode } = useTheme();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    // Open ViperAI with current copy context
    copyTrackingService.openViperAIWithContext();
    
    // Call custom onClick if provided
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className={`copy-tracking-star ${isDarkMode ? 'dark' : ''} ${className}`}
      onClick={handleClick}
      title="Open ViperAI with copied content"
      type="button"
    >
      <Star size={size} />
    </button>
  );
};

export default CopyTrackingStar;
